<div class="navigation flex items-center container" dir="rtl">
  <vex-navigation-item *ngFor="let item of items" [item]="item"></vex-navigation-item>
</div>

